// Calendar dates as YYYY-MM-DD strings. Arithmetic is done on UTC day numbers, so no local
// timezone or DST transition can shift a day. A PTO day is a calendar day, not an instant.
const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;
const MS_PER_DAY = 86_400_000;
function dayNumberOrNaN(s) {
    const m = ISO_DATE.exec(s);
    if (!m)
        return NaN;
    const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
    const ms = Date.UTC(y, mo - 1, d);
    const back = new Date(ms);
    // Reject dates Date.UTC silently rolls over, like 2026-02-30.
    if (back.getUTCFullYear() !== y || back.getUTCMonth() !== mo - 1 || back.getUTCDate() !== d)
        return NaN;
    return ms / MS_PER_DAY;
}
export function isValidISODate(s) {
    return typeof s === 'string' && !Number.isNaN(dayNumberOrNaN(s));
}
export function toDayNumber(s) {
    const n = dayNumberOrNaN(s);
    if (Number.isNaN(n))
        throw new RangeError(`not a YYYY-MM-DD date: ${JSON.stringify(s)}`);
    return n;
}
export function fromDayNumber(n) {
    const dt = new Date(n * MS_PER_DAY);
    return `${dt.getUTCFullYear()}-${String(dt.getUTCMonth() + 1).padStart(2, '0')}-${String(dt.getUTCDate()).padStart(2, '0')}`;
}
export function addDays(s, n) {
    return fromDayNumber(toDayNumber(s) + n);
}
/** Whole calendar days from `a` to `b`; negative when `b` is earlier. */
export function daysBetween(a, b) {
    return toDayNumber(b) - toDayNumber(a);
}
/** 0 = Sunday … 6 = Saturday. */
export function dayOfWeek(s) {
    return new Date(toDayNumber(s) * MS_PER_DAY).getUTCDay();
}
export function isWeekend(s) {
    const w = dayOfWeek(s);
    return w === 0 || w === 6;
}
/**
 * How every date is written: "11/02/2026", MM/DD/YYYY, zero-padded (punch list F193, Jeremy,
 * 2 Nov 2026). String arithmetic only, so no time zone can move the day. Anything that is not a
 * YYYY-MM-DD date comes back unchanged rather than lost.
 */
export function mdy(s) {
    const m = ISO_DATE.exec(s);
    return m ? `${m[2]}/${m[3]}/${m[1]}` : s;
}
/** A range: "11/23/2026 – 11/25/2026"; a single day is just "11/23/2026". */
export function mdyRange(start, end) {
    return start === end ? mdy(start) : `${mdy(start)} – ${mdy(end)}`;
}
/** An instant with its time, in the viewer's own time zone: "11/02/2026 3:15 PM". */
export function mdyTime(instant) {
    const t = new Date(instant);
    if (Number.isNaN(t.getTime()))
        return instant;
    const pad = (n) => String(n).padStart(2, '0');
    const h = t.getHours();
    return `${pad(t.getMonth() + 1)}/${pad(t.getDate())}/${t.getFullYear()} ${h % 12 || 12}:${pad(t.getMinutes())} ${h < 12 ? 'AM' : 'PM'}`;
}
//# sourceMappingURL=dates.js.map